/**
 * Plan slugs as stored in `subscription_plan.slug` on the API side. Renamed from
 * tribe/classic/pro/collectivite by the back's Version20260803120000 — never hardcode a plan
 * *name* in the UI, read it from `subscription.plan.name` so it follows the database and its
 * translations.
 */
export const PlanSlug = {
  Community: 'community',
  Network: 'network',
  Signature: 'signature',
} as const

export type PlanSlug = (typeof PlanSlug)[keyof typeof PlanSlug]

/**
 * Plans that unlock premium pooling features, Réseau upward — the wording the UI already uses
 * ("accessible à partir du plan Réseau"). Community is the free tier and is excluded.
 */
const PREMIUM_PLAN_SLUGS: readonly string[] = [PlanSlug.Network, PlanSlug.Signature]

/**
 * Whether a circle's network plan unlocks co-ownership. Callers hold a slug that came straight
 * from the API, hence the loose `string` input.
 */
export const isPremiumPlanSlug = (slug: string | null | undefined): boolean =>
  slug != null && PREMIUM_PLAN_SLUGS.includes(slug)
